import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import styles from "./CallForwardAddEdit.module.css";
import { DialogContent, DialogTitle, TextField } from "@mui/material";
import { ArrowLeft, X } from "react-feather";
import { useEffect } from "react";
import NumberFormat from "react-number-format";

function PhoneField(props) {
  return (<NumberFormat
    customInput={TextField}
    prefix=""
    displayType="input"
    type="tel"
    format={"(###) ###-####"}
    {...props}
  />);
}

const phoneRegExp = /^\(?([0-9]{3})\)?[ ]?([0-9]{3})[-]?([0-9]{4})$/;
const schema = yup.object().shape({
  name: yup.string().required("This field is Required").max(200, "Name cannot be more than 200 characters"),
  phone: yup.string().required("This field is Required").matches(phoneRegExp, "Invalid phone number"),
});

const CallForwardAddEdit = (props) => {
  const { register, handleSubmit, control, errors, setValue, watch } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
  });

  useEffect(() => {
    if (props.callForwardDetails) {
      setValue("name", props.callForwardDetails.name);
      setValue("phone", props.callForwardDetails.phone);
    } else {
      setValue("name", "");
      setValue("phone", "");
    }
  }, [props.callForwardDetails]);

  const onSubmit = (data) => {
    if (props.callForwardDetails) {
      props.updateCallForward(data);
    } else {
      data.is_archived = 1;
      props.AddCallForward(data);
    }
  };

  return (<>
    <DialogTitle id="alert-dialog-title" className={`${styles.CustomTitle}`}>
      <button className={`${styles.BackAddBU}`} onClick={() => props.handleAddEditForm(false)}>
        <ArrowLeft />
      </button>
      {props.callForwardDetails ? "Edit Number" : "Add Number"}
      <button onClick={(e) => props?.handleCloseModal(false)} className={`${styles.ModalCloseBU}`}>
        <X />
      </button>
    </DialogTitle>
    <DialogContent className={`${styles.RequestBodyPop}`}>
      <div className={`${styles.PromptAddEditSec}`}>
        <form id="myForm" onSubmit={handleSubmit(onSubmit)}>
          <div className={`${styles.FormGroup} FormGroup`}>
            <Controller
              name={`name`}
              control={control}
              render={(field) => (
                <TextField
                  {...field}
                  label="name*"
                  variant="outlined"
                  error={errors?.name}
                />
              )}
            />
            {errors.name && (<p className={`${styles.ErrorM}`}>{errors.name.message}</p>)}
          </div>

          <div className={`${styles.FormGroup} FormGroup`}>
            <Controller
              name={`phone`}
              control={control}
              render={(field) => (<PhoneField
                value={field.value}
                onChange={(e) => field.onChange(e)}
                label="Phone*"
                variant="outlined"
                error={errors?.phone}
              />)}
            />
            {errors.phone && (<p className={`${styles.ErrorM}`}>{errors.phone.message}</p>)}
          </div>
          <div className={`${styles.PromptAddEditButtonSec}`}>
            <button onClick={() => props.handleAddEditForm(false)} className={`${styles.PromptCancelBU}`}>Cancel</button>
            <button type="submit" className={`${styles.PromptAddBU}`}>{!props.callForwardDetails ? "Add" : "Update"}</button>
          </div>
        </form>
      </div>
    </DialogContent>
  </>);
};

export default CallForwardAddEdit;